var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "costunit-list-table" },
    [
      _vm.tableItems.length
        ? _c("b-table", {
            attrs: {
              fields: _vm.fields,
              items: _vm.tableItems,
              responsive: "",
              striped: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-colgroup",
                  fn: function (scope) {
                    return _vm._l(scope.fields, function (field) {
                      return _c("col", {
                        key: field.key,
                        style: { width: field.width ?? "auto" },
                      })
                    })
                  },
                },
                {
                  key: "cell(costUnitText)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.emptyValuePlaceholder(data.value))),
                      ]),
                      _vm._v(" "),
                      data.item.sourceText
                        ? _c("span", [
                            _c("br"),
                            _vm._v(
                              "\n                (" +
                                _vm._s(data.item.sourceText) +
                                ")\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(dateReceipt)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatDate(data.value)) +
                          "\n        "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(amount)",
                  fn: function (data) {
                    return [
                      _c("csp-record-detail-cost-units-amount-table", {
                        attrs: {
                          "amount-property-prefix": "amount",
                          "cost-unit": data.item,
                          "show-insurance-figure-label": "",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(paymentSums)",
                  fn: function (data) {
                    return [
                      !data.item.isDraft
                        ? _c("csp-record-detail-cost-units-amount-table", {
                            attrs: {
                              "amount-property-prefix": "paymentsSum",
                              "cost-unit": data.item,
                              "is-payment": "",
                              "sum-positive-class": "text-success",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(datePaid)",
                  fn: function (data) {
                    return [
                      !data.item.isDraft && data.item.latestPayment.data
                        ? [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatDate(
                                    data.item.latestPayment.data.attributes
                                      .datePaid
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(amountOpen)",
                  fn: function (data) {
                    return [
                      !data.item.isDraft
                        ? _c("csp-record-detail-cost-units-amount-table", {
                            attrs: {
                              "amount-property-prefix": "amountOpen",
                              "cost-unit": data.item,
                              "highlight-insurance-payment": "",
                              "sum-positive-class": "text-danger",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "amountPrefix",
                                  fn: function () {
                                    return [
                                      data.item.hasAmountAdjustment
                                        ? _c("span", [_vm._v("*")])
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(comment)",
                  fn: function (data) {
                    return [
                      _c("span", {
                        staticStyle: { "white-space": "pre-wrap" },
                        domProps: { innerHTML: _vm._s(data.value) },
                      }),
                      _vm._v(" "),
                      data.item.isDraft
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-warning inline-block mt-1",
                            },
                            [
                              _vm._v(
                                "\n                Bitte prüfen - Schadenpositionsdaten aus Rechnungsscan nicht eindeutig\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-actions mb-2",
                          staticStyle: { "text-align": "left" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#", title: "Details anzeigen" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.$emit(
                                    "cost-unit-details",
                                    data.item.id
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "inticon-autoclaim_detail",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          data.item.permissions.canAddCarDealerPayment
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    title: "Zahlung hinzufügen",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit(
                                        "cost-unit-add-car-dealer-payment",
                                        data.item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_hinzufugen",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.permissions.canEdit ||
                          data.item.permissions.canEditPaymentsCarDealer
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Bearbeiten" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit(
                                        "cost-unit-edit",
                                        data.item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_bearbeiten",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.permissions.canDelete
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Löschen" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit(
                                        "cost-unit-delete",
                                        data.item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_loschen",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.isOcrCreated
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Verifizieren" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit(
                                        "cost-unit-verify",
                                        data.item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_done",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      data.item.isOcrCreated
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-1",
                              staticStyle: { "text-align": "left" },
                            },
                            [
                              _vm._v(
                                "\n                via KI erfasst\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      data.item.isOcrConfirmed
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-1",
                              staticStyle: { "text-align": "left" },
                            },
                            [
                              _vm._v(
                                "\n                bestätigte KI-Erfassung\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hideForGroupOptions.length > 0
                        ? _c("csp-hide-for-group", {
                            attrs: {
                              "default-value": data.item.hideForGroup,
                              options: _vm.hideForGroupOptions,
                              "record-id": _vm.recordId,
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              3790782728
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnits.length == 0
        ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
            _vm._v("\n        Keine Schadenpositionen vorhanden.\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }